import React from "react";
import Image from "components/image";

const DiscountCodes = ({ data }) => (
	<div className="flex flex-wrap gap-8">
		{data?.discountItems?.map((item, index) => (
			<div key={index} className="flex w-full md:w-[47%] items-center">
				<div className="p-5 md:p-3 lg:p-5 bg-black w-full sm:w-[60%] lg:w-[55%] h-full flex items-center">
					<div className="text-white p-2.5 flex-center h-full flex-col w-full relative">
						<p className="text-3xl">To Get</p>
						<p className="xl:text-6xl lg:text-4xl text-3xl border-b border-beige pb-2">
							{item.discountPercentage}% OFF
						</p>
						<p className="uppercase text-xl lg:text-3xl text-beige pt-2 text-center">Use code: {item.discountCode}</p>
						{item.label && <p className="uppercase text-base lg:text-xl pt-3 text-center">{item.label}</p>}

						<span className="size-5 border-l border-t top-0 left-0 absolute">&nbsp;</span>
						<span className="size-5 border-r border-t top-0 right-0 absolute">&nbsp;</span>
						<span className="size-5 border-l border-b bottom-0 left-0 absolute">&nbsp;</span>
						<span className="size-5 border-r border-b bottom-0 right-0 absolute">&nbsp;</span>
					</div>
				</div>
				<Image image={item.image} className="!hidden sm:!flex w-[40%] lg:w-[45%] max-h-96" />
			</div>
		))}
	</div>
);

export default DiscountCodes;